import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ArrowLeft, QrCode } from "@phosphor-icons/react";
import { AdminPanel } from "../components/AdminPanel";
import { useLang } from "../context/LangContext";
import api from "../lib/api";

export default function AdminPage() {
  const { t, lang, toggle } = useLang();
  const a = t.admin;
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    api.get("/me/plan")
      .then(({ data }) => {
        if (data.is_admin) setAllowed(true);
        else navigate("/dashboard", { replace: true });
      })
      .catch(() => navigate("/dashboard", { replace: true }));
  }, []);

  if (!allowed) return <div className="min-h-screen bg-[#F8FAFC]" data-testid="admin-page-loading" />;

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="admin-page">
      <Toaster position="top-right" richColors />
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200">
        <div className="mx-auto max-w-5xl px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/dashboard" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-[#0F172A] transition-colors" data-testid="admin-page-back">
              <ArrowLeft size={16} /> Dashboard
            </Link>
            <span className="text-slate-300">|</span>
            <div className="flex items-center gap-2">
              <QrCode size={20} className="text-emerald-600" />
              <span className="font-display font-bold text-[#0F172A]">{a.title}</span>
            </div>
          </div>
          <button onClick={toggle} className="font-mono-tech text-xs font-semibold border border-slate-300 rounded-[4px] px-2 py-1" data-testid="admin-page-lang-toggle">{lang.toUpperCase()}</button>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-10">
        <AdminPanel embedded />
      </main>
    </div>
  );
}
